import { TextInput } from '@mantine/core';

interface InsuranceFormProps {
  insuranceProvider: string;
  memberId: string;
  groupNumber: string;
  onChange: (field: 'insuranceProvider' | 'memberId' | 'groupNumber', value: string) => void;
  disabled?: boolean;
}

export function InsuranceForm({
  insuranceProvider,
  memberId,
  groupNumber,
  onChange,
  disabled = false,
}: InsuranceFormProps) {
  return (
    <div className="space-y-4">
      <TextInput
        label="Insurance Provider"
        placeholder="e.g., Blue Cross Blue Shield"
        value={insuranceProvider}
        onChange={(e) => onChange('insuranceProvider', e.target.value)}
        disabled={disabled}
        classNames={{
          input: 'input',
          label: 'text-sm font-medium text-gray-300 mb-1',
        }}
      />

      <TextInput
        label="Member ID"
        placeholder="e.g., ABC123456789"
        value={memberId}
        onChange={(e) => onChange('memberId', e.target.value)}
        disabled={disabled}
        classNames={{
          input: 'input',
          label: 'text-sm font-medium text-gray-300 mb-1',
        }}
      />

      <TextInput
        label="Group Number"
        placeholder="e.g., 12345 (optional)"
        value={groupNumber}
        onChange={(e) => onChange('groupNumber', e.target.value)}
        disabled={disabled}
        classNames={{
          input: 'input',
          label: 'text-sm font-medium text-gray-300 mb-1',
        }}
      />
    </div>
  );
}
